import {
  OUTREACHES_REQUEST,
  OUTREACHES_SUCCESS,
  OUTREACHES_FAILURE,
  OUTREACH_DETAIL_REQUEST,
  OUTREACH_DETAIL_SUCCESS,
  OUTREACH_DETAIL_FAILURE,
  OUTREACH_TYPES_REQUEST,
  OUTREACH_TYPES_SUCCESS,
  OUTREACH_TYPES_FAILURE,
  REFERRAL_CATEGORIES_REQUEST,
  REFERRAL_CATEGORIES_SUCCESS,
  REFERRAL_CATEGORIES_FAILURE,
  REFERRALDIRECTORY_UPDATE_REQUEST,
  REFERRALDIRECTORY_UPDATE_SUCCESS,
  REFERRALDIRECTORY_UPDATE_FAILURE,
  REFERRALCATEGORY_REQUEST,
  REFERRALCATEGORY_SUCCESS,
  REFERRALCATEGORY_FAILURE,
  REFERRALCATEGORY_DETAILS_REQUEST,
  REFERRALCATEGORY_DETAILS_SUCCESS,
  REFERRALCATEGORY_DETAILS_FAILURE,
} from './OutreachActions';

const initialState = {
  data: [],
  outreach: {},
  error: null,
  isLoading: false,
  isUpdating: false,
  states: null,
  outreachTypes: null,
  referralCategories: null
};

export default function outreachReducer(
  state = initialState,
  { type, payload,  },
) {
  switch (type) {
    case OUTREACHES_REQUEST:
      return { ...state, isLoading: true };
    case OUTREACHES_SUCCESS:
      return {
        ...state,
        data: payload.data,
        outreach: {},
        error: null,
        isLoading: false,
      };
    case OUTREACHES_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case OUTREACH_DETAIL_REQUEST:
      return { ...state, isLoading: true };
    case OUTREACH_DETAIL_SUCCESS:
      return {
        ...state,
        outreach: payload.data,
        error: null,
        isLoading: false,
      };
    case OUTREACH_DETAIL_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case OUTREACH_TYPES_REQUEST:
      return { ...state, isLoading: true };
    case OUTREACH_TYPES_SUCCESS:
      return {
        ...state,
        outreachTypes: payload.data,
        error: null,
        isLoading: false,
      };
    case OUTREACH_TYPES_FAILURE:
      return {
        ...state,
        error: payload.error,
        isLoading: false,
      };

    case REFERRAL_CATEGORIES_REQUEST:
      return { ...state, isLoading: true };
    case REFERRAL_CATEGORIES_SUCCESS:
      return {
        ...state,
        referralCategories: payload.data,
        error: null,
        isLoading: false,
      };
    case REFERRAL_CATEGORIES_FAILURE:
      return {
        ...state,
        error: payload.error,
        isLoading: false,
      };

    case REFERRALDIRECTORY_UPDATE_REQUEST:
      return { ...state, isUpdating: true };
    case REFERRALDIRECTORY_UPDATE_SUCCESS:
      return {
        ...state,
        referral: payload.data,
        error: null,
        isUpdating: false,
      };
    case REFERRALDIRECTORY_UPDATE_FAILURE:
      return { ...state, error: payload.error, isUpdating: false };

    case REFERRALCATEGORY_REQUEST:
      return { ...state, isLoading: true };
    case REFERRALCATEGORY_SUCCESS:
      return {
        ...state,
        data: payload.data,
        referral: {},
        error: null,
        isLoading: false,
      };
    case REFERRALCATEGORY_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case REFERRALCATEGORY_DETAILS_REQUEST:
      return { ...state, isLoading: true };
    case REFERRALCATEGORY_DETAILS_SUCCESS:
      return {
        ...state,
        data: payload.data,
        referral: {},
        error: null,
        isLoading: false,
      };
    case REFERRALCATEGORY_DETAILS_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/outreach/OutreachReducer.js